(function (app) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Home.Marketing",
                {
                    url: "/Marketing",
                    component: "marketing",
                    resolve: {
                        user: ["currentUser", function (currentUser) {
                            return currentUser;
                        }]
                    },
                    redirectTo: "Home.Marketing.MarketingTracker"
                });
        }
    ]);

    app.component("marketing",
        {
            templateUrl: "/App/Marketing/marketing-template.html",
            controller: marketingController,
            bindings: {
                user: "<"
            }
        });

    marketingController.$inject = [];
    function marketingController() {}

})(window.app); // jshint ignore:line